// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background: #eaecfa;
}

.loader {
  width: 250px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  position: absolute;
  top: 31%;
  left: 48%;
  transform: translate(-50%, -50%);
  font-family: helvetica, arial, sans-serif;
  text-transform: uppercase;
  font-weight: 900;
  color: blue;
  letter-spacing: 0.2em;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/custom/pages/Loader.scss"],"names":[],"mappings":"AAGA;EACE,mBAJiB;AAEnB;;AAKA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EAGA,QAAA;EACE,SAAA;EACF,gCAAA;EACA,yCAAA;EACA,yBAAA;EACA,gBAAA;EACA,WApBa;EAqBb,qBAAA;AAJF","sourcesContent":["$color-background: #eaecfa;\n$color-loader: blue;\n\nbody {\n  background: $color-background;\n}\n\n.loader {\n  width: 250px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  position: absolute;\n  // top: 50%;\n  // left: 50%;\n  top: 31%;\n    left: 48%;\n  transform: translate(-50%,-50%);\n  font-family: helvetica, arial, sans-serif;\n  text-transform: uppercase;\n  font-weight: 900;\n  color: $color-loader;\n  letter-spacing: 0.2em;\n  \n  // &::before, &::after {\n  //   content: \"\";\n  //   display: block;\n  //   width: 15px;\n  //   height: 15px;\n  //   background: #0d6efd;\n  //   position: absolute;\n  //   animation: load .7s infinite alternate ease-in-out;\n  // }\n  \n  // &::before {\n  //   top: 0;\n  // }\n  \n  // &::after {\n  //   bottom: 0;\n  // }\n}\n\n// @keyframes load {\n//   0% { left: 0; height: 30px; width: 15px }\n//   50% { height: 8px; width: 40px }\n//   100% { left: 235px; height: 30px; width: 15px}\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
